import { createAction } from 'redux-actions';
import {
    API_EDUMALL_CONTENTS,
} from 'constants/endpoints';
import { StatusEnum } from 'flex/actions/http/StatusEnum';

/**
 * Prefix 付きの ActionType を作成する
 */
const createActionType = <ActionType extends string>(actionType: ActionType) => {
    const prefix = 'CONNECTION/EDUMALL';
    return `${prefix}/${actionType}` as `${typeof prefix}/${ActionType}`;
}


export const search = createAction(
    createActionType('SEARCH' as const),
    (data, page) => {
        const pageNum = page === undefined ? '1' : page;
        return ({ method: 'get', data, api: `${API_EDUMALL_CONTENTS}/${pageNum}` })
    },
    () => ({ fetch: true, status: StatusEnum.REQUEST })
);
